module.exports = "/_next/static/images/icon-slider-tip-14bc65af.png";